export default __webpack_public_path__ + "assets/3263ceb01c4d2f9e9a539be19d559a85.svg";